// extracted by mini-css-extract-plugin
module.exports = {"readNextSection":"BlogReadNext_readNextSection__doNWf","readNextTitle":"BlogReadNext_readNextTitle__lNeYs","readNextPosts":"BlogReadNext_readNextPosts__MNK0A"};